import {Controller} from '@stimulus/core'
import {isPreview} from "../support";

require("../../../../vendor/front/js/hs.core")
require("../../../../vendor/front/js/hs.fancybox")
require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");

export default class extends Controller {
  connect() {
    if (isPreview()) {
      return false
    }

    $.HSCore.components.HSFancyBox.init($(this.element));

    return true
  }
}
